import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const employeeService = {
  get_list_employees_of_department: (token, departmentId, params) => {
    const uri = API_ROUTES.EMPLOYEE.GET_LIST_EMPLOYEES_OF_DEPARTMENT.replace(
      ":departmentId",
      departmentId,
    );

    return https.get(uri, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  get_list_staff_short: (token, params) => {
    const uri = API_ROUTES.EMPLOYEE.GET_LIST_STAFF_SHORT;
    return https.get(uri, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  create_employee: (token, data) => {
    const uri = API_ROUTES.EMPLOYEE.CREATE_EMPLOYEE;
    return https.post(uri, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  get_detail_employee: (token, employeeId) => {
    const uri = `${API_ROUTES.EMPLOYEE.GET_DETAIL_EMPLOYEE.replace(
      ":employeeId",
      employeeId,
    )}`;
    return https.get(uri, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  update_detail_employee: (token, employeeId, data) => {
    const uri = API_ROUTES.EMPLOYEE.UPDATE_EMPLOYEE.replace(
      ":employeeId",
      employeeId,
    );

    return https.put(uri, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};
